import { useEffect } from 'react';
import Highcharts from "highcharts";

const chartColors = {
  Stock: '#2556b5',
  Bond: '#ff8710',
  Cash: '#8fdc2d',
  Other: '#0ecfff',
  Property: '#ed0c30'
};

export default function AssetChart({asset}) {
    useEffect(() => {
        const series = [];
        asset.map(a => {
          if (a.label !== 'Property') {
            series.push({
              name: a.label,
              data: [a.value],
              color: chartColors[a.label]
            });
          }
        });

        Highcharts.chart('container', {
            chart: {
              height: 200,
              type: 'bar'
            },
            legend: { 
              enabled: false 
            },
            title: {
              text: ''
            },
            xAxis: {
              visible : false,
              categories: ['Asset'],
            },
            yAxis: {
              min: -100,
              max: 100,
              title: {
                enabled: false
              },
              gridLineDashStyle: 'Dot'
            },
            credits: {
              enabled: false
            },
            series: series
        });
    }, []);

    return <div className="ajb-col-4 ajb-col-8-breakpoint margin-top-30-sm">
        <div id="container" data-testid="assetAllocationChartContainer"></div>
    </div>
}